"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalAttribName = exports.GlobalContextName = void 0;
exports.GlobalContextName = 'Wranggle';
var GlobalAttribName;
(function (GlobalAttribName) {
    GlobalAttribName["BackendApiBaseUrl"] = "backendApiBaseUrl";
})(GlobalAttribName = exports.GlobalAttribName || (exports.GlobalAttribName = {}));
//# sourceMappingURL=global-context.js.map